import { EListingModalActionType, IToggleListingModalPayload } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const toggleModalAction = actionGenerator<EListingModalActionType.Toggle, IToggleListingModalPayload>(
  EListingModalActionType.Toggle,
);
